export function CancelButton({text, onClick}) {
    return (
        <button
        type="button"
        className="mr-2 inline-flex w-full justify-center items-center rounded-md outline bg-white px-3 py-2 text-sm font-semibold text-red-500 hover:bg-gray-100 sm:mt-0 sm:w-auto"
        onClick={onClick}
      >
        {text}
      </button>
    )
}